import { Component, Output, OnInit, SimpleChanges, EventEmitter } from '@angular/core';
import { EcatalogService } from 'src/app/services/ecatalog.service';
@Component({
  selector: 'app-product-mobile-category',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.less']
})
export class ProductCategoryMobileComponent implements OnInit {
  @Output() selectCategory = new EventEmitter<string>();

  // about category
  categoryVisible: boolean = false;
  allChecked: boolean = false; // choose all category
  currentCategoryName: string = '';
  categoryList: any[] = [];
  allSubCategoryList: any[] = [];

  get selectedSubCategoryList(){
    return  this.allSubCategoryList.filter(item=> item.checked);
  }
  get selectedSubCategoryLabels(){
    return  this.allSubCategoryList?.filter(item=> item.checked)?.length || 0;
  }

  // about vin search 
  vinSearchVisible: boolean = false;
  vinSearchValue: string = "";

  constructor(
    private ecatalogService: EcatalogService
  ) { }

  ngOnInit(): void {
    this.getCategory();
  }

  // change
  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes)
  }

  // view / close brand list model
  handleCloseCategoryDrawer(){
    this.categoryVisible = false;
    this.handleSelectCategory('');
  }
  handleViewAllType(){
    this.categoryVisible = true;
  }
  getCategory():void{
    this.allSubCategoryList = []
    this.ecatalogService.getCategorys({}).subscribe(result=>{
      this.categoryList = result?.rtnData || [];
      this.handleSelectCategory('')
    })
  }
  handleSelectCategory(name: string){
    this.allChecked = false;
    this.currentCategoryName = name;
    this.allSubCategoryList = []
    this.categoryList?.forEach((el: any)=>{
      const items = el.categoryItems.map((subs: any)=>{
        return {
          parentCategoryName: el.categoryName,
          checked: false,
          ...subs
        }
      })
      this.allSubCategoryList = [ ...this.allSubCategoryList, ...items ]
    });
    this.allSubCategoryList = this.allSubCategoryList.filter(item=> (name === '' || item.parentCategoryName === name));
  }
  handleSelectAll(){
    this.allSubCategoryList = this.allSubCategoryList.map(item=> ({ ...item, checked: this.allChecked }))
  }
  handleCancelChecked(item: any){
    const category = this.allSubCategoryList.find(v => item.categoryName === v.categoryName)
    if(category){
      category.checked = false
    }
  }
  handleClearChecked(){
    this.allSubCategoryList = this.allSubCategoryList.map(item=> ({ ...item, checked: false }))
    this.allChecked = false;
  }

  // about vin search 
  handleVinSearchDrawer(){
    this.vinSearchVisible = true;
  }

  handleConfirmSelectCategory(){
    const categoryNames = this.selectedSubCategoryList.map(item=> item.categoryName)
    this.selectCategory.emit(JSON.stringify(categoryNames || []));
    this.categoryVisible = false;
  }
}
